import { Row, Col, Container } from "react-bootstrap"
import { Request } from '@group-devs/yfp7-global-modules'
import { useState, useEffect } from 'react'

const request = new Request(process.env.apiDomain)



export default function ActivitySummary(props) {

    let contactAccount = props.contactAccount
    const [contactId, setContactId] = useState(null);

    useEffect(() => {

        if(typeof contactAccount != 'undefined'){

            setContactId(contactAccount.contact_id)
        }
        
    }, [contactAccount]);

    const contact_id = contactId;
    const { data: articles} = request.stats.articlesRead(contact_id);
    const { data: videos} = request.stats.videoWatch(contact_id);
    const { data: reviews} = request.stats.reviewsGiven(contact_id);
    const { data: recipes} = request.stats.recipeUsed(contact_id);
    const { data: files} = request.stats.filesDownloaded(contact_id);
    const { data: audios} = request.stats.audioListened(contact_id);
    
    const audio = audios ? audios.points : 0
    const file = files ? files.points : 0
    const recipe = recipes ? recipes.points : 0
    const review = reviews ? reviews.points : 0
    const article = articles ? articles.points : 0
    const video = videos ? videos.points : 0

    const summary = 
    [{ name: "Articles Read", icons: "img-small-articles-read-01.svg", num: article },
        { name: "Reviews given", icons: "img-small-reviews-given-01.svg", num: review },
        { name: "Videos watched", icons: "img-small-videos-watched-01.svg", num: video },
        { name: "Recipes used", icons: "img-small-recipes-used-01.svg", num: recipe },
        { name: "Emails opened", icons: "img-small-emails-opened-01.svg", num: "0" },
        { name: "Events attended ", icons: "img-small-events-attended-01.svg", num: "0" },
        { name: "Files downloaded", icons: "img-small-files-downloaded-01.svg", num: file },
        { name: "Audios listened to", icons: "img-small-audios-listened-to-01.svg", num: audio }
    ];

    return (
        <div className="activity-summary">
            <Container>
                <h4 className="font-weight-bold mb-4 pb-3">Activity Summary</h4>
                <ul className="list-unstyled">
                    {summary.map((data, idx) => (
                    <li key={idx} className="mb-4 pb-3"><span className="activity-text"><img src={`/images/learnandearn/${data.icons}`} className="mr-4"/>{data.name}</span> <strong className="h3 text-center font-weight-bold">{data.num}</strong></li>
                    ))}
                </ul>
            </Container>
            <hr className="divider mx-auto "/>
            <style jsx global>{`
                .activity-summary  ul{
                    display: grid!important;
                    align-items: center;
                    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
                }
                .divider{
                    max-width:1439px;
                }
            `}</style>
            <style jsx>{`
                .activity-summary li span{
                    width: 240px;
                    display: inline-block;
                    font-size: 1.1rem;
                }
            `}</style>
        </div>
    )
}